"use strict";

module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/object/keys/is-implemented.js
// module id = ../../../node_modules/es5-ext/object/keys/is-implemented.js
// module chunks = 1